import { DateTime } from './date-helpers'

export const showItem = (now, timeZone, item) => {
  const showAt = item.showAt
    ? DateTime.fromISO(item.showAt, { timeZone })
    : null // publish date
  const hideAt = item.hideAt
    ? DateTime.fromISO(item.hideAt, { timeZone })
    : null // expiry date
  if ((!showAt || now >= showAt) && (!hideAt || now < hideAt)) {
    return true
  } else {
    return false
  }
}
